import React, { useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { ExpandableCard, Flexbox, TextElement } from '@ibinder/common-frontend';
import { GET_ALL_PARTICIPANTS_QUERY } from 'Shared/api/queries/getParticipants.query';
import { GET_USER } from 'Shared/api/queries/getUser.query';
import { GET_BINDER_ACTIVITIES_BY_TYPE } from '../../../../../../api/queries/queries_local';
import { impersonateUser } from '../AdminActionBar/index';
import ImpersonateUserModal from '../AdminActionBar/ImpersonateUserModal';
import { getFormatedDate } from 'Shared/Helpers/dateHelper';
import { ThemeButton } from '@ibinder/ui-common-core';

const UserList = styled.ul`
  padding: 0;
`;

const UserObj = styled(Flexbox)`
  width: 100%;
  padding: 0.5rem;
  overflow-x: auto;
`;

const Information = styled.p`
  font-size: ${({ theme }) => theme.fontStyles.mediumFont.fontSize}px;
  color: ${({ theme }) => theme.colors.discrete50};
`;

const BinderData = ({ binder, organizationId, type }) => {
  const [selectedUser, setSelectedUser] = useState(null);

  localStorage.setItem('tenantId', organizationId);

  // const organizationBinder = useQuery(GET_ORGANIZATION_BINDER, {
  //   fetchPolicy: 'no-cache',
  //   notifyOnNetworkStatusChange: true,
  //   variables: {
  //     organizationId
  //   }
  // });

  // In case of binder tab we need to send in binderId
  const participants = useQuery(GET_ALL_PARTICIPANTS_QUERY, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: {
      binderId: binder.id
    }
  });

  const getUserData = useQuery(GET_USER, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: {
      id: binder.createdByUserId
    }
  });

  const participantList = (participants?.data?.get ?? []).filter(
    (participant) => participant !== null
  );

  const { data } = useQuery(GET_BINDER_ACTIVITIES_BY_TYPE, {
    variables: {
      binderId: binder.id,
      // Seems unlikely to delete and restore a binder more than 10 times...
      pageSize: 10,
      pageNumber: 1,
      body:
        type === 'DeletedBinders'
          ? ['BinderDeletedEvent']
          : ['BinderUpdatedEvent']
    },
    // Only skip if it's an active binder
    skip: type === 'Binders' && binder.state !== 'Archived'
  });

  // pick the lates entry
  const deletedBinderData =
    type === 'DeletedBinders' && data?.get?.data?.length
      ? data.get.data.sort((a, b) => (a.timestamp > b.timestamp ? -1 : 1))?.[0]
      : null;

  const archivedBinderData =
    type !== 'DeletedBinders' && data?.get?.data?.length
      ? data.get.data
          .filter((d) => d.eventData.new.state === 'Archived')
          .sort((a, b) => (a.timestamp > b.timestamp ? -1 : 1))?.[0]
      : null;

  return (
    <>
      {selectedUser && (
        <ImpersonateUserModal
          targetUserId={selectedUser.id}
          userName={selectedUser.fullName}
          onClose={() => setSelectedUser(null)}
          onImpersonated={(token) =>
            impersonateUser(
              token,
              selectedUser.fullName,
              selectedUser.email,
              selectedUser.id,
              binder,
              organizationId
            )
          }
        />
      )}
      <div>
        <Information>Binder name: {binder.name}</Information>
        <Information>
          Created date: {getFormatedDate(binder.createdDate)}
        </Information>
        <Information>
          Created by: {getUserData.data?.getUser?.fullName}
        </Information>
        <Information>
          Created by email: {getUserData.data?.getUser?.email}
        </Information>
        {archivedBinderData && (
          <>
            <Information>
              Archived date: {getFormatedDate(archivedBinderData?.timestamp)}
            </Information>
            <Information>
              Archived by: {archivedBinderData?.user?.name}
            </Information>
            <Information>
              Archived by email: {archivedBinderData?.user?.email}
            </Information>
          </>
        )}
        {type === 'DeletedBinders' && deletedBinderData && (
          <>
            <Information>
              Deleted date: {getFormatedDate(deletedBinderData?.timestamp)}
            </Information>
            <Information>
              Deleted by: {deletedBinderData?.user?.name}
            </Information>
            <Information>
              Deleted by email: {deletedBinderData?.user?.email}
            </Information>
          </>
        )}
      </div>
      <UserList>
        {(participantList ?? [])
          .filter(({ level }) => level === 'Admin')
          .map(({ user }) => {
            return (
              <ExpandableCard
                expanded={false}
                headerInfo={
                  <UserObj
                    alignItems="center"
                    flexDirection={'row'}
                    justifyContent={'space-between'}
                    key={user.id}
                  >
                    <p>{user.fullName}</p>
                  </UserObj>
                }
              >
                <ul>
                  <li>UserId: {user.id}</li>
                  <li>Fullname: {user.fullName}</li>
                  <li>Email: {user.email}</li>
                  <ThemeButton
                    buttonType="default"
                    onClick={() => setSelectedUser(user)}
                  >
                    Impersonate
                  </ThemeButton>
                </ul>
              </ExpandableCard>
            );
          })}
      </UserList>
    </>
  );
};

export default BinderData;
